import type { TSceneEx, TSceneEntityEx } from '@seddi/ui-three-viewer';

import { decode as decodeBuffer } from '../../core/base64';
import type { TSceneEntityJsonDto, TSceneJsonDto } from './sceneJsonDto';

/**
 * Decode entity from JSON DTO.
 * @param src Entity JSON DTO.
 */
const decodeEntity = (src: TSceneEntityJsonDto): TSceneEntityEx => {
  if (!src.components.garmentPiece) {
    return src as unknown as TSceneEntityEx;
  }

  const srcPiece = src.components.garmentPiece!;
  const dst = src as unknown as TSceneEntityEx;
  const dstPiece = dst.components.garmentPiece!;

  dstPiece.geometry.indices = new Uint32Array(decodeBuffer(srcPiece.geometry.indices));
  dstPiece.geometry.position2D = new Float32Array(decodeBuffer(srcPiece.geometry.position2D));
  dstPiece.geometry.position3D = new Float32Array(decodeBuffer(srcPiece.geometry.position3D));
  dstPiece.holeLines = srcPiece.holeLines.map(line => ({
    ...line,
    sides: line.sides!.map(side => ({
      ...side,
      indices: new Uint32Array(decodeBuffer(side.indices)),
    })),
  }));
  dstPiece.interiorLines = srcPiece.interiorLines.map(line => ({
    ...line,
    sides: line.sides!.map(side => ({
      ...side,
      indices: new Uint32Array(decodeBuffer(side.indices)),
    })),
  }));
  dstPiece.sewLine.sides = srcPiece.sewLine.sides!.map(side => ({
    ...side,
    indices: new Uint32Array(decodeBuffer(side.indices)),
  }));

  return dst;
};

export const decodeInPlace = (scene: TSceneJsonDto): TSceneEx => {
  const src = scene;
  const dst = scene as unknown as TSceneEx;
  dst.children = src.children.map(decodeEntity);
  return scene as TSceneEx;
};
